import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { OcadoAuthService } from '../shared/service/auth.service';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { switchMap, take, catchError, of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(OcadoAuthService);
  let url = state.url.slice(1);
  if (url.includes('?')) {
    url = url.split('?')[ 0 ];
  }
  return authService.getPermissionDetails({ section: url });
};


export const tokenGuard: CanActivateFn = () => {
  const ocadoAuthService = inject(OcadoAuthService);
  const auth0 = inject(AuthService);

  return auth0.getAccessTokenSilently().pipe(
    switchMap((accessToken) => {
      return auth0.idTokenClaims$.pipe(
        take(1),
        switchMap((idTokenClaims) => {
          const idToken = idTokenClaims?.__raw || '';
          const obj = {
            access_token: accessToken,
            id_token: idToken,
            scope: 'openid profile email offline_access'
          };
          return ocadoAuthService.getRoleDetails(obj);
        })
      );
    }),
    catchError(() => of(false))
  );
};

export const systemMaintenanceGuard: CanActivateFn = () => {
  const ocadoAuthService = inject(OcadoAuthService);
  const auth0 = inject(AuthService);

  return auth0.getAccessTokenSilently().pipe(
    switchMap((accessToken) => {
      return auth0.idTokenClaims$.pipe(
        take(1),
        switchMap((idTokenClaims) => {
          const idToken = idTokenClaims?.__raw || '';
          const obj = {
            access_token: accessToken,
            id_token: idToken,
            scope: 'openid profile email offline_access'
          };

          if (!ocadoAuthService.isNightlyBatch.value) {
            return ocadoAuthService.checkSystemMaintenance(obj);
          } else {
            ocadoAuthService.isNightlyBatch.next(false);
            return of(true);
          }
        })
      );
    }),
    catchError(() => of(false))
  );
};


export const pageNotFoundGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(OcadoAuthService);
  const router = inject(Router);
  if (state.url.includes('q=')) {
    if (!state.url.includes('summary?q=')) {
      authService.isTokenUnauthorised = true;
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('?promotion_id=')) {
    if (!state.url.includes('promotion-detail?promotion_id=')) {
      authService.isTokenUnauthorised = true;
      router.navigate([ '/unauthorised' ]);
    }
  }
  else if (state.url.includes('?proposal_id=')) {
    if (!state.url.includes('proposal-detail?proposal_id=')) {
      authService.isTokenUnauthorised = true;
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('summary')) {
    if (!state.url.includes('summary?q=')) {
      authService.isTokenUnauthorised = true;
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('qi=')) {
    if (!state.url.includes('manage-invoice?qi=')) {
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('manage-invoice')) {
    if (!state.url.includes('manage-invoice?qi=')) {
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('qcg=')) {
    if (!state.url.includes('manage-customer-group?qcg=')) {
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('manage-customer-group')) {
    if (!state.url.includes('manage-customer-group?qcg=')) {
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('qcgR=')) {
    if (!state.url.includes('customer-group-requests?qcgR=')) {
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('customer-group-requests')) {
    if (!state.url.includes('customer-group-requests?qcgR=')) {
      router.navigate([ '/unauthorised' ]);
    }
  }
  else if (state.url.includes('qre=')) {
    if (!state.url.includes('rule-editor?qre=')) {
      router.navigate([ '/unauthorised' ]);
    }
  } else if (state.url.includes('rule-editor')) {
    if (!state.url.includes('rule-editor?qre=')) {
      router.navigate([ '/unauthorised' ]);
    }
  } else if (!authService.isTokenUnauthorised && state.url.includes('unauthorised')) {
    authService.isTokenUnauthorised = true;
    router.navigate([ '/' ]);
  }
  return true;
};
